export default __webpack_public_path__ + "static/11-profile-0101030ff057a116ee5b395661a38325.png";